import Image from "next/legacy/image";

export default function Communities(){
    return(
        <section id="communities" className='lg:scroll-mt-[150px] md:scroll-mt-[140px] sm:scroll-mt-[130px] scroll-mt-[80px] snap-normal snap-start w-full bg-rapide-yellow py-4 border-t border-gray-200'>
            <div className='max-w-screen-xl mx-auto md:px-12 px-4 py-4'>
                <div className='text-center align-middle items-center py-44 shadow-2xl bg-white'>
                    <h1 className='text-4xl font-semibold pb-4'>Join Our Communities Online</h1>
                    <div className='flex mx-auto justify-center'>
                        <a href="https://invite.viber.com/?g2=AQAAzcQv7e7gqEuk111m15vt8ris9gucx0tOtJPmfcv4sZJZyvp8LMay%2FJzx7gqw" target="_blank" rel="noopener noreferrer">
                            <div className='w-14 h-14 mx-auto'>
                                <Image
                                    alt={'viber-icon'}
                                    src={'/assets/images/club-member/viber.webp'}
                                    layout="responsive"
                                    height={1000}
                                    width={1000}
                                    objectFit="contain"
                                />
                            </div>
                        </a>
                        <a href="https://www.facebook.com/groups/172676639955455" target="_blank" rel="noopener noreferrer">
                            <div className='w-14 h-14 mx-auto'>
                                <Image
                                    alt={'fb-icon'}
                                    src={'/assets/images/club-member/facebook.webp'}
                                    layout="responsive"
                                    height={1000}
                                    width={1000}
                                    objectFit="contain"
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}